import { USER_ROLE_TITLES } from './constants';

/**
 * Returns the initials of a user given their first and last name.
 * @param {Object} user - The user object containing first_name and last_name properties.
 * @returns {string} The user's initials as a string.
 */
export function getUserInitials(user) {
  return [
    user?.first_name?.[0].toUpperCase(),
    user?.last_name?.[0].toUpperCase(),
  ].join('');
}

/**
 * @param {*} name string of full name 'John Doe'
 * @returns string of initials 'JD'
 */
export function getInitials(name) {
  if (!name) return '';
  const names = name.split(' ');
  return names
    .slice(0, 2)
    .map(n => n[0])
    .join('')
    .toUpperCase();
}

/**
 * Returns the username of a passed email
 * @param {*} email
 * @returns
 */
export const getUsername = email => {
  if (!email) return '';
  return email.substring(0, email.indexOf('@'));
};

/**
 * Takes in an array of user role keys and returns a CSV string containing the full role names
 */
export function formatUserRoles(roles_arr) {
  return Object.keys(USER_ROLE_TITLES)
    .filter(role => roles_arr.includes(role))
    .map(role => USER_ROLE_TITLES[role])
    .join(', ');
}
